import {
  Directive,
  Injectable,
  ModuleWithProviders,
  NgModule,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  CdkPortal,
  CdkPortalOutlet,
  ComponentPortal,
  Portal,
  PortalInjector,
  PortalModule,
  TemplatePortal,
} from '@angular/cdk/portal';
import {
  ComponentType,
  ConnectedOverlayPositionChange,
  ConnectedPosition,
  ConnectionPositionPair,
  FlexibleConnectedPositionStrategy,
  Overlay,
  OverlayConfig,
  OverlayContainer,
  OverlayModule,
  OverlayPositionBuilder,
  OverlayRef,
  PositionStrategy,
  ScrollStrategy,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';


@Directive({ selector: '[elPortal]' })
export class ElPortalDirective extends CdkPortal {
}

@Directive({ selector: '[elPortalOutlet]' })
export class ElPortalOutletDirective extends CdkPortalOutlet {
}

export class ElComponentPortal<T = any> extends ComponentPortal<T> {
}

@Injectable()
export class ElOverlay extends Overlay {
}

@Injectable()
export class ElPlatform extends Platform {
}

@Injectable()
export class ElOverlayPositionBuilder extends OverlayPositionBuilder {
}

export class ElTemplatePortal<T = any> extends TemplatePortal<T> {
  constructor(template: TemplateRef<T>, viewContainerRef?: ViewContainerRef, context?: T) {
    super(template, viewContainerRef, context);
  }
}

export class ElOverlayContainer extends OverlayContainer {
}

export class ElFlexibleConnectedPositionStrategy extends FlexibleConnectedPositionStrategy {
}

export class ElPortalInjector extends PortalInjector {
}

export type ElPortal<T = any> = Portal<T>;
export type ElOverlayRef = OverlayRef;
export type ElComponentType<T = any> = ComponentType<T>;
export type ElPositionStrategy = PositionStrategy;
export type ElConnectedPosition = ConnectedPosition;
export type ElConnectedOverlayPositionChange = ConnectedOverlayPositionChange;
export type ElConnectionPositionPair = ConnectionPositionPair;
export type ElOverlayConfig = OverlayConfig;
export type ElScrollStrategyOptions = ScrollStrategyOptions;
export type ElScrollStrategy = ScrollStrategy;

const CDK_MODULES = [OverlayModule, PortalModule];

/**
 * This module helps us to keep all angular/cdk deps inside our cdk module via providing aliases.
 * Approach will help us move cdk in separate npm package and refactor endlessjs/theme code.
 * */
@NgModule({
  imports: [...CDK_MODULES],
  exports: [
    ...CDK_MODULES,
    ElPortalDirective,
    ElPortalOutletDirective,
  ],
  declarations: [ElPortalDirective, ElPortalOutletDirective],
})
export class ElCdkMappingModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ElCdkMappingModule,
      providers: [
        ElOverlay,
        ElPlatform,
        ElOverlayPositionBuilder,
      ],
    };
  }
}
